/**
 *  The directive allows to provide sanitized html into component
 * 	<div v-sanitize-html="html"></div>
 *
 *  Also we can send a sanitation options to directive
 *  <div v-sanitize-html:[options]="html"></div>
 **/

import sanitizeHtml from 'sanitize-html';
import { ObjectDirective, VNodeDirective } from 'vue';
import { ISanitizeOptions } from './index';

const DEFAULT_SANITIZE_OPTIONS: ISanitizeOptions = {
	allowedTags: ['img', 'ol', 'ul', 'li', 'em', 'u', 'strong', 'a', 'div', 'span', 'br', 'p'],
	allowedAttributes: {
		img: ['src', 'alt'],
		a: ['href', 'target']
	},
	allowedSchemesByTag: {
		img: ['data', 'http', 'https'],
		a: ['http', 'https', 'ftp', 'mailto']
	}
};

function updateComponent(el: HTMLElement, binding: VNodeDirective) {
	if (binding.oldValue === binding.value) {
		return;
	}
	const arg = binding.arg as ISanitizeOptions;
	el.innerHTML = sanitizeHtml(binding.value, arg ?? DEFAULT_SANITIZE_OPTIONS);
}

const sanitizeHtmlDirective: ObjectDirective = {
	inserted: updateComponent,
	update: updateComponent
};

export default sanitizeHtmlDirective;
